import { reactive as m, onBeforeMount as y, onBeforeUnmount as h, readonly as w, watch as b } from "vue";
import { hasInstance as v } from "./ghl-ui.es708.js";
import { off as r, on as c } from "./ghl-ui.es710.js";
function B(p = {}, o) {
  const t = m({
    ctrl: !1,
    command: !1,
    win: !1,
    shift: !1,
    tab: !1
  }), { keydown: i, keyup: u } = p, s = (e) => {
    switch (e.key) {
      case "Control":
        t.ctrl = !0;
        break;
      case "Meta":
        t.command = !0, t.win = !0;
        break;
      case "Shift":
        t.shift = !0;
        break;
      case "Tab":
        t.tab = !0;
        break;
    }
    i !== void 0 && Object.keys(i).forEach((a) => {
      if (a !== e.key)
        return;
      const n = i[a];
      if (typeof n == "function")
        n(e);
      else {
        const { stop: d = !1, prevent: l = !1 } = n;
        d && e.stopPropagation(), l && e.preventDefault(), n.handler(e);
      }
    });
  }, f = (e) => {
    switch (e.key) {
      case "Control":
        t.ctrl = !1;
        break;
      case "Meta":
        t.command = !1, t.win = !1;
        break;
      case "Shift":
        t.shift = !1;
        break;
      case "Tab":
        t.tab = !1;
        break;
    }
    u !== void 0 && Object.keys(u).forEach((a) => {
      if (a !== e.key)
        return;
      const n = u[a];
      if (typeof n == "function")
        n(e);
      else {
        const { stop: d = !1, prevent: l = !1 } = n;
        d && e.stopPropagation(), l && e.preventDefault(), n.handler(e);
      }
    });
  }, k = () => {
    (o === void 0 || o.value) && (c("keydown", document, s), c("keyup", document, f)), o !== void 0 && b(o, (e) => {
      e ? (c("keydown", document, s), c("keyup", document, f)) : (r("keydown", document, s), r("keyup", document, f));
    });
  };
  return v() ? (y(k), h(() => {
    (o === void 0 || o.value) && (r("keydown", document, s), r("keyup", document, f));
  })) : k(), w(t);
}
export {
  B as default
};
